import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import RegistrationCivilUnionNotificationShared from 'shell/components/shared/research-notifications/research-civil-union/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface RegistrationCivilUnionDetailAnscNotificationSharedProps {
  isOther?: boolean;
  items?: BreadcrumbItem[];
  scope?: string;
}

const RegistrationCivilUnionDetailAnscNotificationShared = ({
  items,
  isOther,
  scope,
}: RegistrationCivilUnionDetailAnscNotificationSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);
  const idCat = params.idCat || undefined;
  const idNotifica = params.idNotifica || '';

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <RegistrationCivilUnionNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        goBackUrlDetail={goBackUrlDetail}
        isOther={isOther}
      />
    </Fragment>
  );
};

RegistrationCivilUnionDetailAnscNotificationShared.displayName =
  'Research Civil Union Detail Notifications CivilStatusShared component';

export default RegistrationCivilUnionDetailAnscNotificationShared;
